import React from 'react'

import StudioButton from 'material/buttons/StudioButton'
import StudioForm, {yup} from 'studio/StudioForm'
import StudioInput from 'material/input/StudioInput'
import StudioTitleBar from 'studio/StudioTitleBar'


class EmailResetForm extends StudioForm {
    constructor() {super()
        this.state = {emailError: false}
    }

    renderChildren(props) {
        return (
            <React.Fragment>
                <StudioInput
                type='email'
                name='email'
                labelText={props.errors?.email ? props.errors.email : 'Email Address'}
                required={true}
                value={props.values?.email && props.values.email}
                error={this.state.emailError}
                onChange={props.handleChange}/>

                <StudioButton
                type='submit'
                text='Submit'
                variant='contained'
                size='large'
                form={this.formID()}/>
            </React.Fragment>
        )
    }

    initialValues() {
        return {email: ''}
    }

    formID() {
        return 'email-reset-form'
    }

    onSubmit(values) {
        this.REST.POST('email_reset_form', values)
        .then(response => this.handleResponse(response))
    }

     renderTitleBar() {
        return <StudioTitleBar title='Enter Account Email Address'/>
    }

    handleResponse(response) {
        if (response.data.formik_error) {
            return this.setState({[response.data.formik_error]: true})
        }
    }

    formSchema() {
        return yup.object().shape({
            email: yup.string()
            .max(75, 'Invalid Email Format')
            .email('Invalid Email Format'),
        })
    }
}


export default EmailResetForm
